module.exports = __webpack_public_path__ + "img/YK.fd99e110.png";